import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import LanguageToggle from './LanguageToggle';

const Header = () => {
  const { t } = useLanguage();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  
  return (
    <header className="site-header">
      <div className="header-container">
        <Link to="/" className="logo-container" onClick={closeMobileMenu}>
          <img 
            src="https://customer-assets.emergentagent.com/job_scan-match-parts/artifacts/ukg9gyog_ps_logga_fl.png" 
            alt="Partsnap Logo" 
            className="logo"
          />
          <span className="logo-text">
            PART<span className="logo-accent">SNAP</span>
          </span>
        </Link>
        
        <div className="header-actions">
          {/* Desktop Navigation */}
          <nav className="header-nav desktop-nav">
            <Link to="/om-oss" className="nav-link">
              {t('aboutUs')}
            </Link>
            <Link to="/kontakt" className="nav-link">
              {t('contact')}
            </Link>
          </nav>

          {/* Desktop Language Toggle */}
          <div className="desktop-only">
            <LanguageToggle />
          </div>

          {/* Login Link */}
          <a href="/login" className="login-link">
            {t('login')}
          </a>
          
          {/* Mobile Hamburger Menu */}
          <button 
            className="mobile-menu-button" 
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <nav className="mobile-nav">
            <Link to="/om-oss" className="mobile-nav-link" onClick={closeMobileMenu}>
              {t('aboutUs')}
            </Link>
            <Link to="/kontakt" className="mobile-nav-link" onClick={closeMobileMenu}>
              {t('contact')}
            </Link>
            <div className="mobile-menu-language">
              <LanguageToggle />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
